export Form from './Form';



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/reservation/components/index.js